"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToUrlWithDelay = exports.groupSearchRecommendations = exports.getSearchCardImgUrl = exports.getDpxCartUrl = exports.getDomainCompleteApiUrl = exports.getCartUrl = exports.cleanQuery = void 0;
var _utils = require("@site/utils");
var _domainServices = require("@site/domain-services");
var _constants = require("./constants");
// remove all white spaces

const cleanQuery = (query = '') => {
  return query.replace(/\s/g, '');
};
exports.cleanQuery = cleanQuery;
const getDomainCompleteApiUrl = env => {
  return `wss://entourage.${env}.aws.godaddy.com/domain-complete/ws`;
};
exports.getDomainCompleteApiUrl = getDomainCompleteApiUrl;
const getSearchCardImgUrl = (cardType, mediaType) => {
  if (mediaType === 'none') return '';
  const fileName = `searchComparisonCard${cardType === 'basic' ? 'Basic' : 'Ai'}`;
  const fileType = mediaType === 'image' ? '.png' : '.gif';
  return (0, _utils.getImagesBaseUrl)() + 'customSearchDropdown/' + fileName + fileType;
};
exports.getSearchCardImgUrl = getSearchCardImgUrl;
const groupSearchRecommendations = ({
  recommendations = [],
  getIsDomainPurchased = () => {}
}) => {
  const baseRecommendations = recommendations?.filter(({
    recommendation
  }) => !getIsDomainPurchased?.(recommendation.domainName));
  const allRecommendations = baseRecommendations.filter(({
    recommendation
  }) => Object.values(_constants.MATCH_SOURCE).some(matchSource => recommendation.matchSource.match(matchSource)));
  const portfolioRecommendations = allRecommendations.filter(({
    recommendation
  }) => recommendation.matchSource.match(_constants.MATCH_SOURCE.PORTFOLIO));
  const countryRecommendations = allRecommendations.filter(({
    recommendation
  }) => recommendation.matchSource.match(_constants.MATCH_SOURCE.CC_TLD));
  const compactRecommendations = allRecommendations.filter(({
    recommendation
  }) => recommendation.matchSource.match(_constants.MATCH_SOURCE.COMPACT));
  return {
    portfolioRecommendations,
    countryRecommendations,
    compactRecommendations
  };
};
exports.groupSearchRecommendations = groupSearchRecommendations;
const getCartUrl = ({
  apiKey,
  plid,
  env,
  urlOverride
}) => {
  const domainServices = (0, _domainServices.initializeDomainServices)({
    apiKey,
    plid,
    env,
    urlOverride
  });
  const host = domainServices.host;
  const cartHost = host.replace('www.', 'cart.');
  return `${cartHost}`;
};
exports.getCartUrl = getCartUrl;
const getDpxCartUrl = ({
  apiKey,
  plid,
  env,
  urlOverride
}) => {
  const domainServices = (0, _domainServices.initializeDomainServices)({
    apiKey,
    plid,
    env,
    urlOverride
  });
  const host = domainServices.host;
  return `${host}/dpx/registration`;
};
exports.getDpxCartUrl = getDpxCartUrl;
const redirectToUrlWithDelay = (url, delay = 150) => {
  setTimeout(() => {
    window.location.assign(url);
  }, delay);
};
exports.redirectToUrlWithDelay = redirectToUrlWithDelay;